import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Country } from '../../model/myria/app/country';
import { ResourceProvider } from '../../providers/resource/resource';
import { RouteProvider } from '../../providers/route/route';

@Component({
  selector: 'rmt-currency-new',
  templateUrl: 'rmt-currency-new.html'
})
export class RmtCurrencyNewComponent {
  @ViewChild('input') input;
  @ViewChild('input', { read: ElementRef }) inputRef;
  @ViewChild('select') select;
  @Input() currencies;
  @Input() title;
  @Input() placeholder;
  @Input() precision: number = 2;
  @Input() hideInput: boolean = false;
  @Input() inputId: string = "";
  @Output() ionFocus = new EventEmitter<any>();
  @Output() ionBlur = new EventEmitter<any>();
  @Output() ionChange = new EventEmitter<any>();
  @Output() ionChangeStarted = new EventEmitter<any>();
  @Output() keyPress = new EventEmitter<any>();
  amount;
  selectedCurrency;
  changeTimeout;
  allowUpdate: boolean = true;
  lastValue;
  headline;
  colorOutline;

  // new
  actionsheetNavInfo = this.routeProvider.pages.CheckPricesSelectActionsheet;

  constructor(private routeProvider: RouteProvider ) {
  }

  setBorderColor(color) {
    this.colorOutline = color;
  }

  setAmount(amount) {
    this.amount = amount;
    this.input.value = amount;
  }

  setCurrency(currency) {
    this.selectedCurrency = currency;
    window.requestAnimationFrame(() => {
      this.select.setValue(currency, false);
    });
  }

  changeAmount(ev) {
    if (this.changeTimeout)
      window.clearTimeout(this.changeTimeout);
    if (this.amount === ev.value)
      return;

    this.ionChangeStarted.emit(ev.value);
    this.amount = ev.value;

    if (!this.allowUpdate)
      return;

    this.changeTimeout = window.setTimeout(() => {
      this.triggerChange(true);
    }, 300);
  }


  changeCurrency(ev) {

    if (Array.isArray(ev) && ev.length === 0) // bug from ionChange: null currency will be sent as Array
      ev = null;
    this.selectedCurrency = ev;

    if (!this.allowUpdate)
      return;
    this.triggerChange(false);
  }

  triggerChange(changedAmount) {
    if (this.changeTimeout)
      window.clearTimeout(this.changeTimeout);
    this.changeTimeout = null;
    if (this.allowUpdate)
      this.ionChange.emit({ amount: this.amount, currency: this.selectedCurrency, changedAmount: changedAmount });
  }

  focus() {
    if (this.inputRef)
      this.inputRef.nativeElement.getElementsByTagName('input')[0].focus();
  }

  onFocus(ev) {
    this.ionFocus.emit(ev);
    this.setBorderColor('orange');
  }

  onBlur(ev) {
    this.ionBlur.emit(ev);
    this.setBorderColor('black');
  }

  checkAmountPreKey() {
    if (this.validateAmount())
      this.lastValue = this.input.value;
  }

  changeAmountPostKey(ev) {
    if (!this.validateAmount() || (ev.data && !this.input.value))
      this.input.value = this.lastValue;
    let changed = false;
    if (!this.lastValue || this.input.value !== this.lastValue.toString())
      changed = true;
    this.keyPress.emit({
      value: this.input.value,
      changed
    });
  }

  validateAmount() {
    if (this.input.value.length === 0)
      return true;

    const reg = new RegExp('^[0-9]+(\\.[0-9]{0,' + this.precision + '})?$');
    const result = reg.test(this.input.value);
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-currency-new/rmt-currency-new.ts